import { apiHelper } from '../utils/apiHelper';

const API_URL = `${process.env.REACT_APP_API_URL}/api/admin/template`;

const headers = {
  "Content-Type": "multipart/form-data",
  "Accept": "application/json"
};

export const fetchTemplates = (payload) => apiHelper(API_URL, 'GET', payload);
export const createTemplate = (payload) => apiHelper(API_URL, 'POST', payload, headers);
export const fetchTemplate = (templateId) => apiHelper(`${API_URL}/${templateId}`, 'GET');
export const modifyTemplate = (payload) => apiHelper(`${API_URL}/${payload.get('id')}`, 'POST', payload, headers);
export const deleteTemplateApi = (templateId) => apiHelper(`${API_URL}/${templateId}`, 'DELETE');
export const changeStatus = (templateId) => apiHelper(`${API_URL}/change-status/${templateId}`, 'POST');